import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { EntidadesService } from './services/entidades.service';
import { ValidarUrlService } from './services/validar-url.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  userProfile: object;
  userName: string;
  title = "entidades";
  public parametroBuscador: string;
  titleEntidad: string;
  description: string;


  constructor(private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private entidadesService: EntidadesService,
    public validarUrlService: ValidarUrlService,
    private oauthService: OAuthService) {

      this.parametroBuscador = ''

      this.configureImplicitFlow();

      this.oauthService.events
        .pipe(filter(e => e.type === 'token_received'))
        .subscribe(_ => {
          console.debug('state', this.oauthService.state);
          this.oauthService.loadUserProfile();
        });
    }

    private configureImplicitFlow() {
      this.oauthService.configure(authConfig);
      this.oauthService.setStorage(localStorage);

      this.oauthService.loadDiscoveryDocumentAndTryLogin().then(_ => {
        var claims = this.oauthService.getIdentityClaims();
        if (claims){
        this.userName = claims['name'];
        console.log(this.userName);
        }
      });

      var claims = this.oauthService.getIdentityClaims();
      if (claims){
      this.userName = claims['name'];
      console.log(this.userName);
      }

      // Optional
      this.oauthService.setupAutomaticSilentRefresh();

      // Display all events
      this.oauthService.events.subscribe(e => {
        // tslint:disable-next-line:no-console
        console.debug('oauth/oidc event', e);
      });

      this.oauthService.events
        .pipe(filter(e => e.type === 'session_terminated'))
        .subscribe(e => {
          // tslint:disable-next-line:no-console
          console.debug('Your session has been terminated!');
        });
    }

  setTitle() {
    console.log(this.titleService.getTitle());
  }

  ngOnInit() {

    this.validarUrlService.loading$.subscribe( resp => {
      this.validarUrlService.openModal = resp;
    });

    document.documentElement.scrollTop = 0;

    const appTitle = "Inicio";
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title + ' | Gobierno de Colombia');
      })
  }

  loadUserProfile(): void {
    this.oauthService.loadUserProfile().then(up => (this.userProfile = up));
  }

  get givenName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    this.userName = claims['name'];
    return claims['name'];
  }

  get familyName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['email'];
  }

  async refresh() {
    await this.oauthService.loadDiscoveryDocument();
    this.oauthService.oidc = true;

    if (
      !this.oauthService.useSilentRefresh &&
      this.oauthService.responseType === 'code'
    ) {
      this.oauthService
        .refreshToken()
        .then(info => console.debug('refresh ok', info))
        .catch(err => console.error('refresh error', err));
    } else {
      this.oauthService
        .silentRefresh()
        .then(info => console.debug('silent refresh ok', info))
        .catch(err => console.error('silent refresh error', err));
    }
  }

  set requestAccessToken(value: boolean) {
    this.oauthService.requestAccessToken = value;
    localStorage.setItem('requestAccessToken', '' + value);
  }

  get requestAccessToken() {
    return this.oauthService.requestAccessToken;
  }

  set useHashLocationStrategy(value: boolean) {
    const oldValue = localStorage.getItem('useHashLocationStrategy') === 'true';
    if (value !== oldValue) {
      localStorage.setItem('useHashLocationStrategy', value ? 'true' : 'false');
      window.location.reload();
    }
  }

  get useHashLocationStrategy() {
    return localStorage.getItem('useHashLocationStrategy') === 'true';
  }

  get id_token() {
    return this.oauthService.getIdToken();
  }

  get access_token() {
    return this.oauthService.getAccessToken();
  }

  get id_token_expiration() {
    return this.oauthService.getIdTokenExpiration();
  }

  get access_token_expiration() {
    return this.oauthService.getAccessTokenExpiration();
  }
}

